import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';

@Injectable()
export class I18nDateAdapter extends NativeDateAdapter {
  constructor(private translate: TranslateService, private languageService: LanguageService) {
    super();

    // reagálunk a nyelvváltásra
    this.languageService.languageChanged$.subscribe(lang => {
      //console.log('[I18nDateAdapter] locale changed to:', lang);
      this.setLocale(lang);
    });
  }

  override getFirstDayOfWeek(): number {
    return this.translate.getCurrentLang() === 'hu' ? 1 : 0; // hétfő / vasárnap
  }

  override format(date: Date, displayFormat: Object): string {
    const lang = this.translate.getCurrentLang() || 'en';
    const year = date.getFullYear();
    const month = this._to2digit(date.getMonth() + 1);
    const day = this._to2digit(date.getDate());

    if (lang === 'hu') {
      return `${year}.${month}.${day}`;
    }
    return `${month}/${day}/${year}`;
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}